import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import Navbar from './Navbar';
import PushNotificationBanner from '../PushNotificationBanner';

const Layout: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <Container component="main" sx={{ flex: 1, py: 3 }} maxWidth="xl">
        <PushNotificationBanner />
        <Outlet />
      </Container>
    </Box>
  );
};

export default Layout;